class CartCoupons extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      form: 'form[data-checkout-form]',
      checkoutBtn: 'button[name="checkout"]',
      discountInput: 'input[name="discount"]',
    };
    this.boundCheckoutHandle = this.checkoutHandle.bind(this);
  }

  connectedCallback() {
    this.isLogin = !!this.dataset.isLogin;
    if (!this.isLogin) return;
    GkifyEvents.subscribe('InteractionTriggeredTask', () => {
      this.init();
    });
  }

  init() {
    this.domNodes = queryDomNodes(this.selectors, this);
    this.getDiscount();
    this.setupEvent();
    this.updateCart();
  }

  setupEvent() {
    this.domNodes.checkoutBtn.removeEventListener('click', this.boundCheckoutHandle);
    this.domNodes.checkoutBtn.addEventListener('click', this.boundCheckoutHandle);
  }

  updateCart() {
    let cartUpdateUnSubscriber = GkifyEvents.subscribe(GkifyTheme.pubSubEvents.cartUpdate, () => {
      if (cartUpdateUnSubscriber) cartUpdateUnSubscriber();
      this.init();
    });
  }

  async checkoutHandle(e) {
    e.preventDefault();
    e.stopPropagation();

    // 1️⃣ 合并折扣
    const discountInput = this.querySelector(this.selectors.discountInput);
    let discountCode = discountInput.value || '';
    let discounts = this.getDiscountByCodes();
    let resultDiscount = [...new Set(discountCode.split(',').concat(discounts))].filter(Boolean).join(',');
    discountInput.value = resultDiscount;

    // 2️⃣ 检查购物车 variant 是否有效
    const cart = await fetch('/cart.js').then(r => r.json());
    const invalidItems = cart.items.filter(item => !item.variant_id || item.variant_id === 0);

    // 移除无效 variant
    for (const item of invalidItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: item.key ? item.key : item.id, quantity: 0 }),
      });
    }

    // 3️⃣ 安全触发结账
    const triggerButton = document.createElement('button');
    triggerButton.type = 'submit';
    triggerButton.name = 'checkout';
    this.domNodes.form.appendChild(triggerButton);
    triggerButton.click();
  }

  getDiscount() {
    this.loading();
    let params = new URLSearchParams({ status: 'available', limit: 999, page: 1 });
    fetch(`/apps/esrvip/vip/discounts?${params.toString()}`, {
      ...fetchConfig(),
      method: 'GET',
    })
      .then(r => r.json())
      .then(response => {
        this.data = response.data;
      })
      .catch(console.error)
      .finally(() => this.hideLoading());
  }

  getDiscountByCodes() {
    if (!this.data) return [];
    return this.data.list.map(v => v.title);
  }

  loading() {
    this.domNodes.checkoutBtn.classList.add('g-button--loading');
  }

  hideLoading() {
    this.domNodes.checkoutBtn.classList.remove('g-button--loading');
  }
}

customElements.define('g-cart-coupons', CartCoupons);